<template>
  <div class="AppImg">
    <template>
      <div class="left">
        <img
          :src="item.imgUrl"
          title=""
          :class="['translate', isTure ? 'imgMoving show' : '']"
        />
      </div>
      <div class="right">
        <div class="box" :class="['translate', isTure ? 'pMoving show' : '' ,]">
          <i :style="{backgroundImage:'url('+iconUrl+')'}"></i>
          <p class="desc">
            {{ item.name.slice(0,4) }}
            <span class="keyword">{{ item.name.slice(4) }}</span>
          </p>
          <div class="line"></div>
        </div>
        <div class="right-container-text"  :class="['translate', isTure ? 'pMoving' : '']">
          <!-- <div class="article-text">{{ current[index].text1 }}</div> -->
          <!-- <div class="article-text">{{ item.text1 }}</div> -->
          <div class="article-text2">{{ item.text2 }}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    index: Number,
    item: Object,
  },
  data() {
    return {
      isTure: false,
      // index: this.$attrs.index
      iconUrl: this.item.iconUrl
      
    };
  },
  mounted() {
    setTimeout(() => {
      this.isTure = true;
      // console.log(this.index)
      // console.log(this.isTure, this.item);
      console.log(this.isTure)
    }, 500);
    // console.log("this.item",this.item)
  },
};
</script>

<style lang="less" scoped>
.AppImg {
  position: fixed;
  top: -20px;
  left: 278px;
  z-index: 2;
  width: 1873px;
  height: 961px;
  display: flex;
  align-items: center;

  .left {
    width: 458px;
    height: 865px;

    img {
      margin-top: 50px;
      margin-left: -260px;
      // width: 98%;
      // height: 89%;
      transform: scale(0.95);
      opacity: 0;
    }
  }

  .right {
    position: relative;
    width: 1030px;
    height: 961px;

    .box {
      position: relative;
      left: 66%;
      top: 30%;
      display: flex;
      justify-content: flex-end;
      align-items: end;
      i {
        position: relative;
        top: -6px;
        width: 50px;
        height: 50px;
        margin-right: 40px;
        background-repeat: no-repeat;
        background-size: cover;
      }
      .desc {
        color: #000;
        font-size: 50px;
        font-weight: 400;

        .keyword{
          color: #2158fd;
        }
      }
      .line {
        position: relative;
        top: 40px;
        left: -309px;
        width: 100px;
        height: 4px;
        background-color: #000;
      }
    }

    .right-container-text {
      position: relative;
      top: 470px;
      right: -68%;
      display: flex;
      justify-content: flex-end;
      transform: translateX(-200px);
      text-align: center;

      .article-text {
        font-size: 40px;
        font-weight: 600;
      }

      .article-text2 {
        width: 500px;
        // margin: 15px 0;
        font-size: 28px;
        color: #3c3c3c;
        line-height: 100px;
        text-align: left;
        transform: translate(265px, -120px);
      }
    }
  }
  .imgMoving {
    // background:red;
    translate: 260px 0;
  }

  .pMoving {
    translate: -812px 0;
  }

  .translate {
    transition: all 500ms ease 300ms;
  }
  
  .show {
    opacity: 1 !important;
  }
}
</style>
